module.exports = __webpack_public_path__ + "media/30.f5d3e57e.mp4";